import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  contentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: Spacing.Tight,
  },
  discountScaleProgressMiniContainer: {
    marginBottom: Spacing.Tight,
  },
  leftContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Spacing.Condensed,
  },
  discountsTableTitle: {
    color: ColorTypography.TextColorPromo,
  },
  title: {
    color: ColorTypography.TextColorPromo,
    ...textLatoStyleDS.BodyRegularSm,
  },
});
